import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const appDynamics = defineConnector({
  identifier: "appDynamics",
  name: "AppDynamics",
  tagLine: "Application performance monitoring by Cisco",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://[^/]*\\.saas\\.appdynamics\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/controller/api/oauth/access_token`,
        formBody: {
          grant_type: "client_credentials",
          client_id: app.secret.clientName,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an API client",
      items: [
        {
          kind: "markdown",
          content:
            "In your [AppDynamics](https://www.appdynamics.com/) controller, go to **Settings → Administration → API Clients** and create a new client. Copy the client name and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText: "Your AppDynamics controller hostname.",
        },
        {
          kind: "input",
          label: "API client name",
          required: true,
          placeholder: "myclient@myaccount",
          target: { kind: "secrets", field: "clientName" },
          helperText:
            "AppDynamics expects “<apiClientName>@<accountName>” as the OAuth client ID.",
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://${domain}/controller/rest/applications?output=JSON`,
  },
  publicEnvVars: ({ domain }) => ({
    APP_DYNAMICS_URL: domain ? `https://${domain}` : "",
  }),
});
